import Axios from "axios";

export const SelectNomenclatureSC = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/NOME?cat=SC&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({
        type: "NOMENCLATURESC_SELECT",
        payload: response.data,
      });
    });
  };
};
